import React from 'react';

import {BenchlingAppSidepanelQuery} from 'benchling-apps/dashboard/__generated/BenchlingAppSidepanelQuery';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import fuzzydate from 'util/fuzzydate';

import SidepanelItem from './SidepanelItem';

type BenchlingAppSidepanel = BenchlingAppSidepanelQuery['benchlingApps'][number];

interface Props {
  isActive: boolean;
  isCompact: boolean;
  benchlingApp: BenchlingAppSidepanel;
  onOpen: () => void;
  isChild: boolean;
}

const NEVER_SEEN_TEXT = 'Never';

export default function BenchlingAppSidepanelItem(props: Props): JSX.Element {
  const {isActive, isCompact, benchlingApp, isChild} = props;

  const lastSeen = props.benchlingApp.lastSeen;
  return (
    <SidepanelItem
      active={isActive}
      className="sidepanelItem--noIcon"
      faded={false}
      icon={<BenchlingIcon icon={ModelTypeConstants.BENCHLING_APP} />}
      isCompact={isCompact}
      onClick={props.onOpen}
      parties={[]}
      subTitle={`Last Seen: ${lastSeen ? fuzzydate(lastSeen) : NEVER_SEEN_TEXT}`}
      title={{text: benchlingApp.name}}
      tooltipText=""
      isExpandable={false}
      isChild={isChild}
    />
  );
}
